export default "__VITE_ASSET__BAfPi379__"